import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d3e9ec6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "meg1" }
const _hoisted_3 = { class: "meg1" }
const _hoisted_4 = { class: "meg1" }
const _hoisted_5 = { class: "meg1 bott50" }
const _hoisted_6 = { class: "meg1" }
const _hoisted_7 = { class: "meg2 bott50" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line bott50" }, null, -1))
const _hoisted_9 = { class: "meg1" }
const _hoisted_10 = { class: "meg2 bott50" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { class: "meg1" }
const _hoisted_13 = { class: "meg2 bott50 ue-versions-box" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = { class: "meg1" }
const _hoisted_17 = { class: "meg2 bott50" }
const _hoisted_18 = { class: "meg1" }
const _hoisted_19 = { class: "meg2 bott50" }
const _hoisted_20 = { class: "meg1" }
const _hoisted_21 = { class: "meg2 bott50" }
const _hoisted_22 = { class: "meg1" }
const _hoisted_23 = { class: "meg3 bott50" }
const _hoisted_24 = { class: "meg1" }
const _hoisted_25 = { class: "meg3 bott50" }
const _hoisted_26 = { class: "meg1" }
const _hoisted_27 = { class: "meg1" }
const _hoisted_28 = { class: "meg1" }
const _hoisted_29 = { class: "meg1" }
const _hoisted_30 = { class: "meg4 bott50" }
const _hoisted_31 = { class: "submit" }

import { ref, reactive } from "vue";
import { getContactUs } from "@/api/contact-us";
import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";
import "@/style/bind.scss";
import i18n from "@/lang";
import store from "@/store";

export default /*#__PURE__*/_defineComponent({
  __name: 'constactUs',
  setup(__props) {

const isMobile = store.state.isMobile;
const checkedOtherRef = ref(false);
const isRenderRef = ref(false);
const isMirrorRef = ref(false);
const isMDecRef = ref(false);
const router = useRouter();
const input1 = ref(""); //
const input2 = ref("");
const input3 = ref("");
const input5 = ref("");
const input6 = ref("");
const input7 = ref("");
const input8 = ref("");
const input12 = ref("");
const input13 = ref("");
const input16 = ref("");
const input15 = ref("");
const checkList = ref([]); //
const checkList2 = ref([]); //
const checkList3 = ref([]); //
const checkList4 = ref([]); //
const checkList5 = ref([]); //
const checkList6 = ref([]); //
const checkList7 = ref([]); //
const value = ref(""); //
const $t = i18n.global.t;
const options = [
  {
    value: "1~20" + $t("user_center.people"),
    label: "1~20" + $t("user_center.people"),
  },
  {
    value: "20~50" + $t("user_center.people"),
    label: "20~50" + $t("user_center.people"),
  },
  {
    value: "50~100" + $t("user_center.people"),
    label: "50~100" + $t("user_center.people"),
  },
  {
    value: "100~200" + $t("user_center.people"),
    label: "100~200" + $t("user_center.people"),
  },
  {
    value: "200+",
    label: "200+",
  },
];
const radio1 = ref("1"); //
let input = ref("");
const textarea = ref("");
//联系我们
const contackUsAjax = () => {
  let array1 = [],
    array4 = [],
    array5 = [],
    array6 = [];
  array1 = [...checkList.value];
  if (checkedOtherRef.value && input15.value) {
    array1 = array1.concat([input15.value]);
  }
  array4 = [...checkList4.value];
  if (isRenderRef.value && input12.value) {
    array4 = array4.concat([input12.value]);
  }
  array5 = [...checkList5.value];
  if (isMirrorRef.value && input13.value) {
    array5 = array5.concat([input13.value]);
  }
  array6 = [...checkList6.value];
  if (isMDecRef.value && input16.value) {
    array6 = array6.concat([input16.value]);
  }
  if (!input1.value) {
    ElMessage.error($t("us.company_name"));
    return;
  }
  if (!input2.value) {
    ElMessage.error($t("us.company_url"));
    return;
  }
  if (!input3.value) {
    ElMessage.error($t("us.company_address"));
    return;
  }
  if (!value.value) {
    ElMessage.error($t("us.company_teams"));
    return;
  }
  if (array1.length == 0) {
    ElMessage.error($t("us.main_business"));
    return;
  }
  if (checkList2.value.length == 0) {
    ElMessage.error($t("us.maya_version"));
    return;
  }
  if (checkList3.value.length == 0) {
    ElMessage.error($t("us.ue_version"));
    return;
  }
  if (array4.length == 0) {
    ElMessage.error($t("us.select_use"));
    return;
  }
  if (array5.length == 0) {
    ElMessage.error($t("us.check_use"));
    return;
  }
  if (array6.length == 0) {
    ElMessage.error($t("us.nown_dec_mirror"));
    return;
  }

  if (checkList7.value.length == 0) {
    ElMessage.error($t("us.dec_mirror"));
    return;
  }
  if (!input5.value) {
    ElMessage.error($t("us.what"));
    return;
  }
  if (!input6.value) {
    ElMessage.error($t("user_center.please_your_phone_and_mobile"));
    return;
  }
  if (!input7.value) {
    ElMessage.error($t("user_center.please_enter_job"));
    return;
  }
  if (!input8.value) {
    ElMessage.error($t("user_center.please_enter_email"));
    return;
  }
  let interested = checkList7.value.join(",");
  let mayaVersion = checkList2.value.join(",");
  let mainBusiness = array1.join(",");
  let renderer = array4.join(",");
  let renderEngine = array5.join(",");
  let isKnowDec = array6.join(",");
  let ueVersion = checkList3.value.join(",");
  let obj = {
    companyNickname: input1.value,
    websiteAddress: input2.value,
    headquarterBase: input3.value,
    groupScale: value.value,
    mainBusiness: mainBusiness,
    mayaVersion: mayaVersion,
    ueVersion: ueVersion,
    renderer: renderer,
    renderEngine: renderEngine,
    isUseDec: radio1.value,
    isKnowDec: isKnowDec,
    interested: interested,
    contactNickname: input5.value,
    position: input7.value,
    mobile: input6.value,
    email: input8.value,
    remark: textarea.value,
  };
  getContactUs(obj).then((res: any) => {
    if (res.code == 0) {
      ElMessage.success($t("user_center.submit_success"));
      router.push({ path: "/privilege" });
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _component_SecondPageHeader = _resolveComponent("SecondPageHeader")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_radio = _resolveComponent("el-radio")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["contact", { 'mobile-contact': _unref(isMobile) }])
  }, [
    (_unref(isMobile))
      ? (_openBlock(), _createBlock(_component_SecondPageHeader, {
          key: 0,
          title: _unref($t)('novice_guidance.step_boxFive.step_name'),
          toPath: "/privilege"
        }, null, 8, ["title"]))
      : _createCommentVNode("", true),
    _createElementVNode("h2", {
      innerHTML: _unref($t)('us.base_info')
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, _toDisplayString(_unref($t)("user_center.company_name")), 1),
      _createVNode(_component_el_input, {
        modelValue: input1.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((input1).value = $event)),
        placeholder: _unref($t)('user_center.please_enter_company_name')
      }, null, 8, ["modelValue", "placeholder"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", null, _toDisplayString(_unref($t)("user_center.website_address")), 1),
      _createVNode(_component_el_input, {
        modelValue: input2.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((input2).value = $event)),
        placeholder: _unref($t)('user_center.please_enter_address_url')
      }, null, 8, ["modelValue", "placeholder"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("p", null, _toDisplayString(_unref($t)("user_center.headquarters_location")), 1),
      _createVNode(_component_el_input, {
        modelValue: input3.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((input3).value = $event)),
        placeholder: _unref($t)('user_center.please_enter_company_headquarters')
      }, null, 8, ["modelValue", "placeholder"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("p", null, _toDisplayString(_unref($t)("user_center.team_software")), 1),
      _createVNode(_component_el_select, {
        modelValue: value.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((value).value = $event)),
        class: "m-2",
        placeholder: _unref($t)('user_center.please_team_software')
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, (item) => {
            return _createVNode(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"])
          }), 64))
        ]),
        _: 1
      }, 8, ["modelValue", "placeholder"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("p", null, _toDisplayString(_unref($t)("user_center.main_bus_multiple")), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_el_checkbox_group, {
        modelValue: checkList.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((checkList).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_checkbox, {
            label: _unref($t)('user_center.animated_drama')
          }, null, 8, ["label"]),
          _createVNode(_component_el_checkbox, {
            label: _unref($t)('user_center.animated_film')
          }, null, 8, ["label"]),
          _createVNode(_component_el_checkbox, {
            label: _unref($t)('user_center.vfx')
          }, null, 8, ["label"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_checkbox, {
        modelValue: checkedOtherRef.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((checkedOtherRef).value = $event)),
        label: _unref($t)('user_center.other')
      }, null, 8, ["modelValue", "label"]),
      (checkedOtherRef.value)
        ? (_openBlock(), _createBlock(_component_el_input, {
            key: 0,
            modelValue: input15.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((input15).value = $event)),
            placeholder: _unref($t)('user_center.other')
          }, null, 8, ["modelValue", "placeholder"]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("p", null, _toDisplayString(_unref($t)("user_center.maya_vresion")), 1)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_el_checkbox_group, {
        modelValue: checkList2.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((checkList2).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_checkbox, { label: "2022" }),
          _createVNode(_component_el_checkbox, { label: "2021" }),
          _createVNode(_component_el_checkbox, { label: "2020" }),
          _createVNode(_component_el_checkbox, { label: "2019" }),
          _hoisted_11,
          _createVNode(_component_el_checkbox, { label: "2018" }),
          _createVNode(_component_el_checkbox, { label: "2017" }),
          _createVNode(_component_el_checkbox, {
            label: _unref($t)('user_center.version_before', { version: '2017' })
          }, null, 8, ["label"]),
          _createVNode(_component_el_checkbox, {
            label: _unref($t)('user_center.not_use_maya')
          }, null, 8, ["label"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("p", null, _toDisplayString(_unref($t)("user_center.ue_version")), 1)
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_el_checkbox_group, {
        modelValue: checkList3.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((checkList3).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_checkbox, { label: "5.0" }),
          _createVNode(_component_el_checkbox, { label: "4.27" }),
          _createVNode(_component_el_checkbox, { label: "4.26" }),
          _createVNode(_component_el_checkbox, { label: "4.25" }),
          _createVNode(_component_el_checkbox, { label: "4.24" }),
          _createVNode(_component_el_checkbox, { label: "4.23" }),
          _hoisted_14,
          _createVNode(_component_el_checkbox, { label: "4.22" }),
          _createVNode(_component_el_checkbox, { label: "4.20" }),
          _createVNode(_component_el_checkbox, {
            label: _unref($t)('user_center.version_before', { version: '4.20' })
          }, null, 8, ["label"]),
          _createVNode(_component_el_checkbox, {
            label: _unref($t)('user_center.not_use_ue')
          }, null, 8, ["label"]),
          _hoisted_15,
          _createVNode(_component_el_checkbox, {
            label: _unref($t)('user_center.internally_version')
          }, null, 8, ["label"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("p", null, _toDisplayString(_unref($t)("user_center.renderer_used")), 1)
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_component_el_checkbox_group, {
        modelValue: checkList4.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((checkList4).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_checkbox, { label: "Arnold" }),
          _createVNode(_component_el_checkbox, { label: "Vray" }),
          _createVNode(_component_el_checkbox, { label: "Renderman" }),
          _createVNode(_component_el_checkbox, { label: "Red Shif" })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("div", null, [
        _createVNode(_component_el_checkbox, {
          modelValue: isRenderRef.value,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((isRenderRef).value = $event)),
          label: _unref($t)('user_center.other')
        }, null, 8, ["modelValue", "label"]),
        (isRenderRef.value)
          ? (_openBlock(), _createBlock(_component_el_input, {
              key: 0,
              modelValue: input12.value,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((input12).value = $event)),
              placeholder: _unref($t)('user_center.other')
            }, null, 8, ["modelValue", "placeholder"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("p", null, _toDisplayString(_unref($t)("user_center.real_time_rendering")), 1)
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createVNode(_component_el_checkbox_group, {
        modelValue: checkList5.value,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((checkList5).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_checkbox, { label: "Unreal Engine 4" }),
          _createVNode(_component_el_checkbox, { label: "Unity 3D" }),
          _createVNode(_component_el_checkbox, { label: "Blender" }),
          _createVNode(_component_el_checkbox, {
            label: _unref($t)('user_center.none')
          }, null, 8, ["label"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("div", null, [
        _createVNode(_component_el_checkbox, {
          modelValue: isMirrorRef.value,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((isMirrorRef).value = $event)),
          label: _unref($t)('user_center.other')
        }, null, 8, ["modelValue", "label"]),
        (isMirrorRef.value)
          ? (_openBlock(), _createBlock(_component_el_input, {
              key: 0,
              modelValue: input13.value,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((input13).value = $event)),
              placeholder: _unref($t)('user_center.other')
            }, null, 8, ["modelValue", "placeholder"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("p", null, _toDisplayString(_unref($t)("user_center.did_you_use_dec")), 1)
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createVNode(_component_el_radio, {
        modelValue: radio1.value,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((radio1).value = $event)),
        label: "1"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref($t)("user_center.used")), 1)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_radio, {
        modelValue: radio1.value,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((radio1).value = $event)),
        label: "2"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref($t)("user_center.no_used")), 1)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("p", null, _toDisplayString(_unref($t)("user_center.how_know")), 1)
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createVNode(_component_el_checkbox_group, {
        modelValue: checkList6.value,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((checkList6).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_checkbox, {
            label: _unref($t)('user_center.friend_recommend')
          }, null, 8, ["label"]),
          _createVNode(_component_el_checkbox, {
            label: _unref($t)('user_center.chinese_video')
          }, null, 8, ["label"]),
          _createVNode(_component_el_checkbox, {
            label: _unref($t)('user_center.other_video')
          }, null, 8, ["label"]),
          _createVNode(_component_el_checkbox, {
            label: _unref($t)('user_center.public_account')
          }, null, 8, ["label"]),
          _createVNode(_component_el_checkbox, {
            label: _unref($t)('user_center.official_website')
          }, null, 8, ["label"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("div", null, [
        _createVNode(_component_el_checkbox, {
          modelValue: isMDecRef.value,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((isMDecRef).value = $event)),
          label: _unref($t)('user_center.other')
        }, null, 8, ["modelValue", "label"]),
        (isMDecRef.value)
          ? (_openBlock(), _createBlock(_component_el_input, {
              key: 0,
              modelValue: input16.value,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((input16).value = $event)),
              placeholder: _unref($t)('user_center.other')
            }, null, 8, ["modelValue", "placeholder"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("p", null, _toDisplayString(_unref($t)("user_center.most_interested")), 1)
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createVNode(_component_el_checkbox_group, {
        modelValue: checkList7.value,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((checkList7).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_checkbox, {
            label: _unref($t)('user_center.viewport_2')
          }, null, 8, ["label"]),
          _createVNode(_component_el_checkbox, {
            label: _unref($t)('user_center.complex_animation')
          }, null, 8, ["label"]),
          _createVNode(_component_el_checkbox, {
            label: _unref($t)('user_center.click_to_push')
          }, null, 8, ["label"]),
          _createVNode(_component_el_checkbox, {
            label: _unref($t)('user_center.playblast_output')
          }, null, 8, ["label"]),
          _createVNode(_component_el_checkbox, {
            label: _unref($t)('user_center.free_allocation')
          }, null, 8, ["label"]),
          _createVNode(_component_el_checkbox, {
            label: _unref($t)('user_center.ue_large_scenes')
          }, null, 8, ["label"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("p", null, _toDisplayString(_unref($t)("user_center.prefered_title")), 1),
      _createVNode(_component_el_input, {
        modelValue: input5.value,
        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((input5).value = $event)),
        placeholder: _unref($t)('user_center.please_enter_name')
      }, null, 8, ["modelValue", "placeholder"])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("p", null, _toDisplayString(_unref($t)("user_center.your_phone_and_mobile")), 1),
      _createVNode(_component_el_input, {
        modelValue: input6.value,
        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((input6).value = $event)),
        placeholder: _unref($t)('user_center.please_your_phone_and_mobile')
      }, null, 8, ["modelValue", "placeholder"])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("p", null, _toDisplayString(_unref($t)("user_center.your_job_title")), 1),
      _createVNode(_component_el_input, {
        modelValue: input7.value,
        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((input7).value = $event)),
        placeholder: _unref($t)('user_center.please_enter_job')
      }, null, 8, ["modelValue", "placeholder"])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("p", null, _toDisplayString(_unref($t)("user_center.your_email")), 1),
      _createVNode(_component_el_input, {
        modelValue: input8.value,
        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((input8).value = $event)),
        placeholder: _unref($t)('user_center.please_enter_email')
      }, null, 8, ["modelValue", "placeholder"])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("p", null, _toDisplayString(_unref($t)("user_center.special_info_remark")), 1),
      _createVNode(_component_el_input, {
        modelValue: textarea.value,
        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((textarea).value = $event)),
        rows: 2,
        type: "textarea",
        placeholder: _unref($t)('user_center.leave_your_remark')
      }, null, 8, ["modelValue", "placeholder"])
    ]),
    _createElementVNode("div", _hoisted_31, [
      _createElementVNode("a", {
        href: "javascript:;",
        onClick: contackUsAjax
      }, _toDisplayString(_unref($t)("forgot_password.confirm")), 1)
    ])
  ], 2))
}
}

})